// PHASE 8: What keeps you accountable?
import SingleChoiceQuestionPage from '@app-studio-web/ui/pages/SingleChoiceQuestionPage'
import { AnswerType } from '@app-studio-web/ui/types'

const answers: AnswerType[] = [
  {
    emoji: '🔥',
    title: 'pages.onboarding.accountabilityStyle.answer1',
    subtitle: 'pages.onboarding.accountabilityStyle.answer1Subtitle',
  },
  {
    emoji: '👥',
    title: 'pages.onboarding.accountabilityStyle.answer2',
    subtitle: 'pages.onboarding.accountabilityStyle.answer2Subtitle',
  },
  {
    emoji: '📊',
    title: 'pages.onboarding.accountabilityStyle.answer3',
    subtitle: 'pages.onboarding.accountabilityStyle.answer3Subtitle',
  },
  {
    emoji: '🏆',
    title: 'pages.onboarding.accountabilityStyle.answer4',
    subtitle: 'pages.onboarding.accountabilityStyle.answer4Subtitle',
  },
  {
    emoji: '⏰',
    title: 'pages.onboarding.accountabilityStyle.answer5',
    subtitle: 'pages.onboarding.accountabilityStyle.answer5Subtitle',
  },
]

export default function AccountabilityStylePage() {
  return (
    <SingleChoiceQuestionPage
      answers={answers}
      title="pages.onboarding.accountabilityStyle.title"
      subtitle="pages.onboarding.accountabilityStyle.subtitle"
    />
  )
}
